/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum DiscountApplicationType {
  flat = "flat",
  percent = "percent",
}

export enum DiscountType {
  age = "age",
  breeder = "breeder",
  marketing = "marketing",
  multipet = "multipet",
  points = "points",
  referral = "referral",
}

export enum PaymentMethodEnum {
  STRIPE = "STRIPE",
  TRUSTLY = "TRUSTLY",
  TRUSTLY_MDD = "TRUSTLY_MDD",
}

export enum PaymentTransactionStatus {
  Disputed = "Disputed",
  Failed = "Failed",
  Incomplete = "Incomplete",
  Pending = "Pending",
  PendingSucceeded = "PendingSucceeded",
  Succeded = "Succeded",
}

export enum PayoutMethodEnum {
  ATLAR = "ATLAR",
  PAYPAL = "PAYPAL",
  TRUSTLY = "TRUSTLY",
  TRUSTLY_MDD = "TRUSTLY_MDD",
}

export enum ProductEnum {
  cat = "cat",
  dog = "dog",
  liability = "liability",
}

export enum SpeciesEnum {
  cat = "cat",
  dog = "dog",
}

export interface ArticleFilter {
  AND?: (ArticleFilter | null)[] | null;
  OR?: (ArticleFilter | null)[] | null;
  author?: cfAuthorNestedFilter | null;
  author_exists?: boolean | null;
  breeds?: cfBreedNestedFilter | null;
  breedsCollection_exists?: boolean | null;
  category?: cfTopicNestedFilter | null;
  category_exists?: boolean | null;
  content_contains?: string | null;
  content_exists?: boolean | null;
  content_not_contains?: string | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  fromBirthWeek?: number | null;
  fromBirthWeek_exists?: boolean | null;
  fromBirthWeek_gt?: number | null;
  fromBirthWeek_gte?: number | null;
  fromBirthWeek_in?: (number | null)[] | null;
  fromBirthWeek_lt?: number | null;
  fromBirthWeek_lte?: number | null;
  fromBirthWeek_not?: number | null;
  fromBirthWeek_not_in?: (number | null)[] | null;
  mainImage_exists?: boolean | null;
  metadataTitle?: string | null;
  metadataTitle_contains?: string | null;
  metadataTitle_exists?: boolean | null;
  metadataTitle_in?: (string | null)[] | null;
  metadataTitle_not?: string | null;
  metadataTitle_not_contains?: string | null;
  metadataTitle_not_in?: (string | null)[] | null;
  org_contains_all?: (string | null)[] | null;
  org_contains_none?: (string | null)[] | null;
  org_contains_some?: (string | null)[] | null;
  org_exists?: boolean | null;
  readTime?: number | null;
  readTime_exists?: boolean | null;
  readTime_gt?: number | null;
  readTime_gte?: number | null;
  readTime_in?: (number | null)[] | null;
  readTime_lt?: number | null;
  readTime_lte?: number | null;
  readTime_not?: number | null;
  readTime_not_in?: (number | null)[] | null;
  relatedArticles?: cfArticleNestedFilter | null;
  relatedArticlesCollection_exists?: boolean | null;
  seoDescription?: string | null;
  seoDescription_contains?: string | null;
  seoDescription_exists?: boolean | null;
  seoDescription_in?: (string | null)[] | null;
  seoDescription_not?: string | null;
  seoDescription_not_contains?: string | null;
  seoDescription_not_in?: (string | null)[] | null;
  shortText?: string | null;
  shortText_contains?: string | null;
  shortText_exists?: boolean | null;
  shortText_in?: (string | null)[] | null;
  shortText_not?: string | null;
  shortText_not_contains?: string | null;
  shortText_not_in?: (string | null)[] | null;
  species?: cfSpeciesNestedFilter | null;
  species_exists?: boolean | null;
  sys?: SysFilter | null;
  title?: string | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  title_in?: (string | null)[] | null;
  title_not?: string | null;
  title_not_contains?: string | null;
  title_not_in?: (string | null)[] | null;
  toBirthWeek?: number | null;
  toBirthWeek_exists?: boolean | null;
  toBirthWeek_gt?: number | null;
  toBirthWeek_gte?: number | null;
  toBirthWeek_in?: (number | null)[] | null;
  toBirthWeek_lt?: number | null;
  toBirthWeek_lte?: number | null;
  toBirthWeek_not?: number | null;
  toBirthWeek_not_in?: (number | null)[] | null;
  topics?: cfTopicNestedFilter | null;
  topicsCollection_exists?: boolean | null;
  uri?: string | null;
  uri_contains?: string | null;
  uri_exists?: boolean | null;
  uri_in?: (string | null)[] | null;
  uri_not?: string | null;
  uri_not_contains?: string | null;
  uri_not_in?: (string | null)[] | null;
  video?: cfVideoNestedFilter | null;
  video_exists?: boolean | null;
}

export interface ChangePaymentMethodInput {
  paymentMethodId: string;
  paymentMethod: PaymentMethodEnum;
}

export interface ChangePayoutMethodInput {
  payoutMethodId?: string | null;
  payoutMethod?: PayoutMethodEnum | null;
}

export interface ChargeInput {
  paymentCandidateId: string;
}

export interface CheckMultiBindInput {
  draftId: string;
}

export interface ClientDraftAddressInput {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  zip: string;
}

export interface ClientDraftInput {
  firstName?: string | null;
  lastName?: string | null;
  ssn?: any | null;
  email?: string | null;
  birthdate?: string | null;
  phone?: string | null;
  region?: string | null;
  address?: ClientDraftAddressInput | null;
  allowMarketing?: boolean | null;
}

export interface CompleteSetupPaymentMethodInput {
  paymentMethodSetupId?: string | null;
  paymentMethod?: PaymentMethodEnum | null;
  payoutMethod?: PayoutMethodEnum | null;
}

export interface ContentfulMetadataConceptsDescendantsFilter {
  id_contains_all?: (string | null)[] | null;
  id_contains_some?: (string | null)[] | null;
  id_contains_none?: (string | null)[] | null;
}

export interface ContentfulMetadataConceptsFilter {
  id_contains_all?: (string | null)[] | null;
  id_contains_some?: (string | null)[] | null;
  id_contains_none?: (string | null)[] | null;
  descendants?: ContentfulMetadataConceptsDescendantsFilter | null;
}

export interface ContentfulMetadataFilter {
  tags?: ContentfulMetadataTagsFilter | null;
  tags_exists?: boolean | null;
  concepts_exists?: boolean | null;
  concepts?: ContentfulMetadataConceptsFilter | null;
}

export interface ContentfulMetadataTagsFilter {
  id_contains_all?: (string | null)[] | null;
  id_contains_none?: (string | null)[] | null;
  id_contains_some?: (string | null)[] | null;
}

export interface FaqItemFilter {
  AND?: (FaqItemFilter | null)[] | null;
  OR?: (FaqItemFilter | null)[] | null;
  answer_contains?: string | null;
  answer_exists?: boolean | null;
  answer_not_contains?: string | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  name?: string | null;
  name_contains?: string | null;
  name_exists?: boolean | null;
  name_in?: (string | null)[] | null;
  name_not?: string | null;
  name_not_contains?: string | null;
  name_not_in?: (string | null)[] | null;
  question?: string | null;
  question_contains?: string | null;
  question_exists?: boolean | null;
  question_in?: (string | null)[] | null;
  question_not?: string | null;
  question_not_contains?: string | null;
  question_not_in?: (string | null)[] | null;
  sys?: SysFilter | null;
}

export interface GetBreedsInput {
  limit?: number | null;
  species?: SpeciesEnum | null;
  search?: string | null;
}

export interface InitMultiBindInput {
  draftId: string;
  paymentMethod: PaymentMethodEnum;
  data?: PaymentMethodData | null;
}

export interface IsSignaturePresentInput {
  binary?: string | null;
}

export interface PaymentMethodData {
  type?: string | null;
  iban?: string | null;
  returnUrl?: string | null;
}

export interface PolicyDraftInput {
  _id: string;
  productName: ProductEnum;
  effectiveDate: string;
  billingInterval: number;
  billingDay?: number | null;
  limit: number;
  deductible: number;
  ratingsData: PolicyDraftRatingsDataInput;
  metadata: PolicyDraftMetadataInput;
}

export interface PolicyDraftMetadataInput {
  animalId?: string | null;
  draftAnimalId?: string | null;
  discount?: string | null;
  healthHistory?: string | null;
  insuranceHistory?: string | null;
  previousInsurance?: string | null;
  cancelPreviousInsurance?: boolean | null;
  customerSignature?: string | null;
  eurobonusMemberId?: string | null;
  lunarMemberId?: string | null;
  compare?: boolean | null;
  chipNumber?: string | null;
  partner?: string | null;
  attribution?: string | null;
}

export interface PolicyDraftRatingsDataInput {
  name: string;
  breed: string;
  birthday: string;
  sex: string;
  lifeLimit?: number | null;
  copay?: number | null;
  breedersAddOn?: boolean | null;
  lifeUtilityAddOn?: string | null;
  access?: string | null;
  clientBirthdate?: string | null;
  liabilityBestAddOn?: boolean | null;
  liabilitySosAddOn?: boolean | null;
  liabilityRentedAddOn?: boolean | null;
  preventiveCareAddOnLimit?: number | null;
  preexistingConditions?: boolean | null;
}

export interface QuotePreviewInput {
  id: string;
}

export interface RemovePaymentMethodInput {
  paymentMethodId: string;
  paymentMethod: PaymentMethodEnum;
}

export interface ResumeDraftInput {
  _id: string;
}

export interface SetupPaymentMethodInput {
  paymentMethod: PaymentMethodEnum;
  data?: PaymentMethodData | null;
}

export interface SysFilter {
  firstPublishedAt?: any | null;
  firstPublishedAt_exists?: boolean | null;
  firstPublishedAt_gt?: any | null;
  firstPublishedAt_gte?: any | null;
  firstPublishedAt_in?: (any | null)[] | null;
  firstPublishedAt_lt?: any | null;
  firstPublishedAt_lte?: any | null;
  firstPublishedAt_not?: any | null;
  firstPublishedAt_not_in?: (any | null)[] | null;
  id?: string | null;
  id_contains?: string | null;
  id_exists?: boolean | null;
  id_in?: (string | null)[] | null;
  id_not?: string | null;
  id_not_contains?: string | null;
  id_not_in?: (string | null)[] | null;
  publishedAt?: any | null;
  publishedAt_exists?: boolean | null;
  publishedAt_gt?: any | null;
  publishedAt_gte?: any | null;
  publishedAt_in?: (any | null)[] | null;
  publishedAt_lt?: any | null;
  publishedAt_lte?: any | null;
  publishedAt_not?: any | null;
  publishedAt_not_in?: (any | null)[] | null;
  publishedVersion?: number | null;
  publishedVersion_exists?: boolean | null;
  publishedVersion_gt?: number | null;
  publishedVersion_gte?: number | null;
  publishedVersion_in?: (number | null)[] | null;
  publishedVersion_lt?: number | null;
  publishedVersion_lte?: number | null;
  publishedVersion_not?: number | null;
  publishedVersion_not_in?: (number | null)[] | null;
}

export interface TopicFilter {
  AND?: (TopicFilter | null)[] | null;
  OR?: (TopicFilter | null)[] | null;
  color?: string | null;
  color_contains?: string | null;
  color_exists?: boolean | null;
  color_in?: (string | null)[] | null;
  color_not?: string | null;
  color_not_contains?: string | null;
  color_not_in?: (string | null)[] | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  icon?: string | null;
  iconBackground?: string | null;
  iconBackground_contains?: string | null;
  iconBackground_exists?: boolean | null;
  iconBackground_in?: (string | null)[] | null;
  iconBackground_not?: string | null;
  iconBackground_not_contains?: string | null;
  iconBackground_not_in?: (string | null)[] | null;
  iconColor?: string | null;
  iconColor_contains?: string | null;
  iconColor_exists?: boolean | null;
  iconColor_in?: (string | null)[] | null;
  iconColor_not?: string | null;
  iconColor_not_contains?: string | null;
  iconColor_not_in?: (string | null)[] | null;
  icon_contains?: string | null;
  icon_exists?: boolean | null;
  icon_in?: (string | null)[] | null;
  icon_not?: string | null;
  icon_not_contains?: string | null;
  icon_not_in?: (string | null)[] | null;
  image_exists?: boolean | null;
  name?: string | null;
  name_contains?: string | null;
  name_exists?: boolean | null;
  name_in?: (string | null)[] | null;
  name_not?: string | null;
  name_not_contains?: string | null;
  name_not_in?: (string | null)[] | null;
  species?: cfSpeciesNestedFilter | null;
  species_exists?: boolean | null;
  sys?: SysFilter | null;
  uri?: string | null;
  uri_contains?: string | null;
  uri_exists?: boolean | null;
  uri_in?: (string | null)[] | null;
  uri_not?: string | null;
  uri_not_contains?: string | null;
  uri_not_in?: (string | null)[] | null;
}

export interface UpsertDraftInput {
  _id?: string | null;
  clientInput?: ClientDraftInput | null;
  policyInputs?: PolicyDraftInput[] | null;
}

export interface cfArticleNestedFilter {
  AND?: (cfArticleNestedFilter | null)[] | null;
  OR?: (cfArticleNestedFilter | null)[] | null;
  author_exists?: boolean | null;
  breedsCollection_exists?: boolean | null;
  category_exists?: boolean | null;
  content_contains?: string | null;
  content_exists?: boolean | null;
  content_not_contains?: string | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  fromBirthWeek?: number | null;
  fromBirthWeek_exists?: boolean | null;
  fromBirthWeek_gt?: number | null;
  fromBirthWeek_gte?: number | null;
  fromBirthWeek_in?: (number | null)[] | null;
  fromBirthWeek_lt?: number | null;
  fromBirthWeek_lte?: number | null;
  fromBirthWeek_not?: number | null;
  fromBirthWeek_not_in?: (number | null)[] | null;
  mainImage_exists?: boolean | null;
  metadataTitle?: string | null;
  metadataTitle_contains?: string | null;
  metadataTitle_exists?: boolean | null;
  metadataTitle_in?: (string | null)[] | null;
  metadataTitle_not?: string | null;
  metadataTitle_not_contains?: string | null;
  metadataTitle_not_in?: (string | null)[] | null;
  org_contains_all?: (string | null)[] | null;
  org_contains_none?: (string | null)[] | null;
  org_contains_some?: (string | null)[] | null;
  org_exists?: boolean | null;
  readTime?: number | null;
  readTime_exists?: boolean | null;
  readTime_gt?: number | null;
  readTime_gte?: number | null;
  readTime_in?: (number | null)[] | null;
  readTime_lt?: number | null;
  readTime_lte?: number | null;
  readTime_not?: number | null;
  readTime_not_in?: (number | null)[] | null;
  relatedArticlesCollection_exists?: boolean | null;
  seoDescription?: string | null;
  seoDescription_contains?: string | null;
  seoDescription_exists?: boolean | null;
  seoDescription_in?: (string | null)[] | null;
  seoDescription_not?: string | null;
  seoDescription_not_contains?: string | null;
  seoDescription_not_in?: (string | null)[] | null;
  shortText?: string | null;
  shortText_contains?: string | null;
  shortText_exists?: boolean | null;
  shortText_in?: (string | null)[] | null;
  shortText_not?: string | null;
  shortText_not_contains?: string | null;
  shortText_not_in?: (string | null)[] | null;
  species_exists?: boolean | null;
  sys?: SysFilter | null;
  title?: string | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  title_in?: (string | null)[] | null;
  title_not?: string | null;
  title_not_contains?: string | null;
  title_not_in?: (string | null)[] | null;
  toBirthWeek?: number | null;
  toBirthWeek_exists?: boolean | null;
  toBirthWeek_gt?: number | null;
  toBirthWeek_gte?: number | null;
  toBirthWeek_in?: (number | null)[] | null;
  toBirthWeek_lt?: number | null;
  toBirthWeek_lte?: number | null;
  toBirthWeek_not?: number | null;
  toBirthWeek_not_in?: (number | null)[] | null;
  topicsCollection_exists?: boolean | null;
  uri?: string | null;
  uri_contains?: string | null;
  uri_exists?: boolean | null;
  uri_in?: (string | null)[] | null;
  uri_not?: string | null;
  uri_not_contains?: string | null;
  uri_not_in?: (string | null)[] | null;
  video_exists?: boolean | null;
}

export interface cfAuthorNestedFilter {
  AND?: (cfAuthorNestedFilter | null)[] | null;
  OR?: (cfAuthorNestedFilter | null)[] | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  name?: string | null;
  name_contains?: string | null;
  name_exists?: boolean | null;
  name_in?: (string | null)[] | null;
  name_not?: string | null;
  name_not_contains?: string | null;
  name_not_in?: (string | null)[] | null;
  portrait_exists?: boolean | null;
  sys?: SysFilter | null;
  title?: string | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  title_in?: (string | null)[] | null;
  title_not?: string | null;
  title_not_contains?: string | null;
  title_not_in?: (string | null)[] | null;
}

export interface cfBreedNestedFilter {
  AND?: (cfBreedNestedFilter | null)[] | null;
  OR?: (cfBreedNestedFilter | null)[] | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  id?: string | null;
  id_contains?: string | null;
  id_exists?: boolean | null;
  id_in?: (string | null)[] | null;
  id_not?: string | null;
  id_not_contains?: string | null;
  id_not_in?: (string | null)[] | null;
  lifeAgeGroup?: number | null;
  lifeAgeGroup_exists?: boolean | null;
  lifeAgeGroup_gt?: number | null;
  lifeAgeGroup_gte?: number | null;
  lifeAgeGroup_in?: (number | null)[] | null;
  lifeAgeGroup_lt?: number | null;
  lifeAgeGroup_lte?: number | null;
  lifeAgeGroup_not?: number | null;
  lifeAgeGroup_not_in?: (number | null)[] | null;
  name?: string | null;
  name_contains?: string | null;
  name_exists?: boolean | null;
  name_in?: (string | null)[] | null;
  name_not?: string | null;
  name_not_contains?: string | null;
  name_not_in?: (string | null)[] | null;
  species_exists?: boolean | null;
  sys?: SysFilter | null;
}

export interface cfSpeciesNestedFilter {
  AND?: (cfSpeciesNestedFilter | null)[] | null;
  OR?: (cfSpeciesNestedFilter | null)[] | null;
  code?: string | null;
  code_contains?: string | null;
  code_exists?: boolean | null;
  code_in?: (string | null)[] | null;
  code_not?: string | null;
  code_not_contains?: string | null;
  code_not_in?: (string | null)[] | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  name?: string | null;
  name_contains?: string | null;
  name_exists?: boolean | null;
  name_in?: (string | null)[] | null;
  name_not?: string | null;
  name_not_contains?: string | null;
  name_not_in?: (string | null)[] | null;
  sys?: SysFilter | null;
}

export interface cfTopicNestedFilter {
  AND?: (cfTopicNestedFilter | null)[] | null;
  OR?: (cfTopicNestedFilter | null)[] | null;
  color?: string | null;
  color_contains?: string | null;
  color_exists?: boolean | null;
  color_in?: (string | null)[] | null;
  color_not?: string | null;
  color_not_contains?: string | null;
  color_not_in?: (string | null)[] | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  icon?: string | null;
  iconBackground?: string | null;
  iconBackground_contains?: string | null;
  iconBackground_exists?: boolean | null;
  iconBackground_in?: (string | null)[] | null;
  iconBackground_not?: string | null;
  iconBackground_not_contains?: string | null;
  iconBackground_not_in?: (string | null)[] | null;
  iconColor?: string | null;
  iconColor_contains?: string | null;
  iconColor_exists?: boolean | null;
  iconColor_in?: (string | null)[] | null;
  iconColor_not?: string | null;
  iconColor_not_contains?: string | null;
  iconColor_not_in?: (string | null)[] | null;
  icon_contains?: string | null;
  icon_exists?: boolean | null;
  icon_in?: (string | null)[] | null;
  icon_not?: string | null;
  icon_not_contains?: string | null;
  icon_not_in?: (string | null)[] | null;
  image_exists?: boolean | null;
  name?: string | null;
  name_contains?: string | null;
  name_exists?: boolean | null;
  name_in?: (string | null)[] | null;
  name_not?: string | null;
  name_not_contains?: string | null;
  name_not_in?: (string | null)[] | null;
  species_exists?: boolean | null;
  sys?: SysFilter | null;
  uri?: string | null;
  uri_contains?: string | null;
  uri_exists?: boolean | null;
  uri_in?: (string | null)[] | null;
  uri_not?: string | null;
  uri_not_contains?: string | null;
  uri_not_in?: (string | null)[] | null;
}

export interface cfVideoNestedFilter {
  AND?: (cfVideoNestedFilter | null)[] | null;
  OR?: (cfVideoNestedFilter | null)[] | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  lengthSeconds?: number | null;
  lengthSeconds_exists?: boolean | null;
  lengthSeconds_gt?: number | null;
  lengthSeconds_gte?: number | null;
  lengthSeconds_in?: (number | null)[] | null;
  lengthSeconds_lt?: number | null;
  lengthSeconds_lte?: number | null;
  lengthSeconds_not?: number | null;
  lengthSeconds_not_in?: (number | null)[] | null;
  media_exists?: boolean | null;
  mux_exists?: boolean | null;
  placeholderImage_exists?: boolean | null;
  sys?: SysFilter | null;
  title?: string | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  title_in?: (string | null)[] | null;
  title_not?: string | null;
  title_not_contains?: string | null;
  title_not_in?: (string | null)[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
